import { CognitoAuthError, MagicLinkResult } from '@cpd-app/core-module/models';
import { AuthError, SignInOutput } from 'aws-amplify/auth';

export class CognitoAuthMapper {
  static mapToCognitoAuthError(error: AuthError): CognitoAuthError {
    return {
      name: (error.name as string) || 'AuthError',
      message: (error.message as string) || 'An authentication error occurred',
      recoverySuggestion:
        (error.recoverySuggestion as string) || 'Please try again',
      ...error
    } as CognitoAuthError;
  }

  static mapToMagicLinkResult(result: SignInOutput): MagicLinkResult {
    const nextStep = result.nextStep;

    return {
      challengeName: 'CUSTOM_CHALLENGE',
      isSignedIn: (result.isSignedIn as boolean) || false,
      nextStep: nextStep
        ? {
            signInStep: nextStep.signInStep,
            additionalInfo: nextStep['additionalInfo']
          }
        : undefined
    };
  }
}
